module.exports = __webpack_public_path__ + "static/media/criacao_digital.a78ef487.jpg";